import { setTimeout } from 'core-js';

export default () => {
  const el = document.querySelector('[data-range-filter-overrides]');

  if (el) {
    // selectors
    const selectors = {
      displayBlock: '.bc-sf-filter-block-content',
      optionBlockSize: '.bc-sf-filter-option-block-size',
      optionBlockRange: '.bc-sf-filter-option-block-range',
      label: '.bc-sf-filter-option-item',
      removeSelectionLink: '.bc-sf-filter-selected-items a',
      filterValue: '.bc-sf-filter-option-value',
      filterAmount: '.bc-sf-filter-option-amount',
      filterList: '.bc-sf-filter-option-multiple-list',
      productImages: '.bc-sf-filter-product-item-image',
      activateMultiFilter: '.bc-sf-filter-select-button',
    };

    // function for removing double lines and replacing with...
    const removeDoubleLines = () => {
      const values = document.querySelectorAll(selectors.filterValue);
      values.forEach((value) => {
        if (value.innerHTML.length > 15) {
          value.innerHTML = `${value.innerHTML.slice(0, 15)}...`;
        }
      });
    };
    const handleFilterSizes = () => {
      const optionBlockSize = document.querySelector(selectors.optionBlockSize);
      const optionBlockRange = document.querySelector(selectors.optionBlockRange);
      if (!optionBlockRange) return;
      if (!optionBlockSize) {
        optionBlockRange.classList.add('bc-sf-filter-option-block--only-one');
      } else {
        optionBlockRange.classList.add('bc-sf-filter-option-block--two');
      }
    };

    window.onload = setTimeout(() => {
      handleFilterSizes();
      // removeDoubleLines();
    }, 1000);

    // event listeners

    el.addEventListener('click', (e) => {
      let targetElement = e.srcElement;
      // if the user selects something from the multi-element list, apply the filters.
      if (targetElement.classList.contains(selectors.filterValue.replace('.', '')) || targetElement.classList.contains(selectors.filterAmount.replace('.', ''))) {
        document.querySelectorAll(selectors.activateMultiFilter).forEach((button) => button.click());
      }

      setTimeout(() => {
        handleFilterSizes();
        // removeDoubleLines();
      }, 500);

      const clickRemoveSelectors = (el) => {
        if (el.innerText === targetElement.querySelector(selectors.filterValue).innerText) {
          el.click();
        }
      };

      // event bubbling handle click on option/label
      while (targetElement !== e.currentTarget) {
        // if the clicked object is the label
        if (targetElement.matches(selectors.label)) {
          // if label is selected turn it off
          if (targetElement.matches('.selected')) {
            const removeSelectionLinks = e.currentTarget

              .querySelectorAll(selectors.removeSelectionLink);

            removeSelectionLinks.forEach(clickRemoveSelectors);
          }
        }
        targetElement = targetElement.parentElement;
      }
    });
  }
};
